var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUngroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247.99999999999997,
    height: 248.99999999999997,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 248 249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 251,
    width: 250,
    y: -1,
    x: -1
  }), /*#__PURE__*/React.createElement("g", {
    display: "none",
    overflow: "visible",
    y: 0,
    x: 0,
    height: "100%",
    width: "100%",
    id: "canvasGrid"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#gridpattern)",
    strokeWidth: 0,
    y: 0,
    x: 0,
    height: "100%",
    width: "100%"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    strokeDasharray: 20,
    id: "svg_1",
    height: 213.999997,
    width: 213.999997,
    y: 18.040149,
    x: 16.8611,
    strokeWidth: 16,
    stroke: "#000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 39.5,
    rx: 39.5,
    id: "svg_2",
    cy: 87.605177,
    cx: 90.239139,
    strokeOpacity: "null",
    strokeWidth: 5,
    stroke: "#000",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "svg_3",
    height: 61.636373,
    width: 61.636373,
    y: 135.606293,
    x: 133.750604,
    strokeOpacity: "null",
    strokeWidth: 5,
    stroke: "#000",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngroup);
export default __webpack_public_path__ + "static/media/ungroup.f97458691a470c6eee6f0d61d7f68e8d.svg";
export { ForwardRef as ReactComponent };